import * as React from 'react';
import styles from './search-tile.scss';

import type { JSX } from "react";

interface SearchTileComponentProps {
  componentId?: string;
  className?: string;
  footer?: JSX.Element;
  header?: JSX.Element;
  deleted?: boolean;
  children?: React.ReactNode;
}
export const SearchTile: React.FC<React.PropsWithChildren<SearchTileComponentProps & React.PropsWithChildren>> = ({
  componentId, className, header, children, footer, deleted
}) => (
    <article
      id={componentId}
      className={`${styles.searchTile} ${deleted ? styles.searchTileDeleted : ''} ${!!className ? className : ''}`}>
      {header && <header>
        {header}
      </header>}
      <main>
        {children}
      </main>
      {footer && <footer>
        {footer}
      </footer>}
    </article>
  );
